module.exports = __webpack_public_path__ + "static/media/04_hero_mobile.b64964cc.jpg";